import type { JSX, ReactNode } from 'react';

import { AmplitudeProvider } from './AmplitudeProvider';
import { SegmentProvider } from './SegmentProvider';

interface AnalyticsProviderProps {
  writeKey: string;
  amplitudeKey: string;
  amplitudeServerUrl?: string;
  children: ReactNode;
}

export const AnalyticsProvider = (
  props: AnalyticsProviderProps
): JSX.Element => {
  return (
    <SegmentProvider writeKey={props.writeKey}>
      <AmplitudeProvider
        apiKey={props.amplitudeKey}
        serverUrl={props.amplitudeServerUrl}
      >
        {props.children}
      </AmplitudeProvider>
    </SegmentProvider>
  );
};
